import { IOsaExecucaoFolhaTesteModel, IOsaExecucaoFolhaTesteQuestaoModel } from "./../../../../../models/osa-execucao-folha-teste-model";
import { OsaExecucaoFolhaTesteService } from "./../../../../../services/osa-execucao-folha-teste.service";
import { OsaExecucaoAbaFolhaTesteQuestaoResponderComponent } from "./../osa-execucao-aba-folha-teste-questao-responder/osa-execucao-aba-folha-teste-questao-responder.component";
import { Component, Inject, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import Swal from "sweetalert2";
import { AuthService } from "./../../../../../services/auth.service";
import { OsaExecucaoAbaFolhaTesteQuestaoHistoricoComponent } from "./../osa-execucao-aba-folha-teste-questao-historico/osa-execucao-aba-folha-teste-questao-historico.component";

@Component({
  selector: 'app-osa-execucao-aba-folha-teste-questao',
  templateUrl: './osa-execucao-aba-folha-teste-questao.component.html',
  styleUrls: ['./osa-execucao-aba-folha-teste-questao.component.scss']
})
export class OsaExecucaoAbaFolhaTesteQuestaoComponent implements OnInit, AfterViewInit {

  public osaExecucaoId: number = 0;
  public id: number = 0;
  public dataSource = new MatTableDataSource<IOsaExecucaoFolhaTesteQuestaoModel>([]);
  public visualizar: boolean = false;
  public titulo: string = "";

  public model: IOsaExecucaoFolhaTesteModel = {} as IOsaExecucaoFolhaTesteModel;
  public numeroOsa: string = "";
  public unidadeGestoraNome: string = "";
  public numeroFolha: number = 0;
  public amostraItemDescricao: string = "";
  public amostraNome: string = "";

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    public matDialog: MatDialog,
    public serviceOsaExecucaoFolhaTeste: OsaExecucaoFolhaTesteService,
    private dialogRef: MatDialogRef<OsaExecucaoAbaFolhaTesteQuestaoComponent>,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.osaExecucaoId = data?.osaExecucaoId || 0;
    this.id = data?.id || 0;
    this.visualizar = data?.visualizar || false;
    this.titulo = data?.titulo || '';
    this.numeroOsa = data?.numeroOsa || '';
  }

  ngOnInit(): void {
    this.buscar();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
  }

  public sortingDataAccessor = (item, property) => {
    switch (property) {
      case "identificador": return item?.ordem;
      case "descricao": return item?.questao?.nome;
      case "avaliacao": return item?.avaliacao;
      case "responsavel": return item?.responsavelNome;
      case "status": return item?.status;
      default: return item[property];
    }
  };


  public buscar() {

    this.serviceOsaExecucaoFolhaTeste
      .obterFolhaTestePorId(this.id)
      .then((res) => {
        if (res.sucesso) {
          this.model = res.dados;
          this.unidadeGestoraNome = this.model.unidadeGestora?.sigla || '';
          this.numeroFolha = this.model.numeroFolha || 0;
          this.amostraItemDescricao = this.model.amostraItemDescricao || '';
          this.amostraNome = this.model.amostra?.nome || '';

          this.dataSource.data = this.model.questoes || [];

          this.cdr.detectChanges();
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
        }
      })
      .catch((err) => {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: err?.mensagem?.descricao || 'Erro ao carregar dados',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      });
  }

  public modalResponder(titulo: string, visualizar: boolean, element?: IOsaExecucaoFolhaTesteQuestaoModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-folha-teste-questao-responder";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "140vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = { titulo, visualizar, id: element?.id, element, osaExecucaoId: this.osaExecucaoId };

    const modal = this.matDialog.open(OsaExecucaoAbaFolhaTesteQuestaoResponderComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.buscar();
      }
    });
  }

  public modalHistorico(element?: IOsaExecucaoFolhaTesteQuestaoModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-folha-teste-questao-historico";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "140vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = { id: element?.id, identificador: element?.identificador, idFuncionalidade: 35 };

    const modal = this.matDialog.open(OsaExecucaoAbaFolhaTesteQuestaoHistoricoComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.buscar();
      }
    });
  }

  getDescricaoQuestao(element: any): string {

    if (element.questaoId) {

      if (element.procedimentoAuditoria?.nome) {
        return element.procedimentoAuditoria.nome;
      }

      if (element.questao?.nome) {
        return element.questao.nome;
      }

      return '-';
    }

    if (element.descricaoProcedimentoQI) {
      return element.descricaoProcedimentoQI;
    }

    if (element.descricaoQI) {
      return element.descricaoQI;
    }

    return '-';
  }

  public fechar() {
    this.dialogRef.close(!this.visualizar);
  }
}
